import React, { FC } from 'react';
import {
 Button, Intent, FormGroup, InputGroup
} from '@blueprintjs/core';
import { useTranslation } from 'react-i18next';
import { AgGridReact } from '@ag-grid-community/react';
import { CellValueChangedEvent } from '@ag-grid-community/core';
import { fqdpDomainColumnDefs } from '../fqdn.types'
import { DomainFormItem } from '../hooks/useDomainForm'
import { ActionCellRenderer, DomainNameCellRenderer } from './FrameworkComponents';

interface FqdnDomainFormGridProps {
  domainGroup: string,
  domainNames: DomainFormItem[],
  setDomainGroup: (name: string) => void,
  onClickAddDomainItem: () => void
  onCellValueChanged: (event: CellValueChangedEvent) => void
  onClickRemoveDomainItem: (domain: DomainFormItem) => void
}

const components = {
  actionCellRenderer: ActionCellRenderer,
  domainNameCellRenderer: DomainNameCellRenderer
};

export const FqdnDomainFormGrid: FC<FqdnDomainFormGridProps> = ({
 domainNames, domainGroup, setDomainGroup, onClickAddDomainItem, onCellValueChanged, onClickRemoveDomainItem
}) => {
    const { t } = useTranslation();

    return (
      <div style={{ height: '100%', maxWidth: '500px' }} data-testid="FqdnFields">
        <FormGroup
          label={t('fqdn.grid.domainGroup')}
          labelFor="text-input"
          labelInfo={<small style={{ color: '#DE4343' }}>*</small>}
          style={{ border: 'none', padding: 0, margin: 0 }}
        >
          <InputGroup value={domainGroup} onChange={({ target }) => setDomainGroup(target.value)} />
        </FormGroup>
        <Button
          minimal
          icon="add"
          intent={Intent.PRIMARY}
          data-testid="addDeviceButton"
          text={t('fqdn.form.newDomainName')}
          style={{ margin: '0.5rem 0' }}
          onClick={onClickAddDomainItem}
          disabled={domainNames.length >= 5}
        />
        { domainNames.length > 0 && (
          <div className="ag-theme-balham fqdn-domain-form-grid" style={{ height: '100%', minHeight: '65px' }}>
            <AgGridReact
              stopEditingWhenCellsLoseFocus
              rowData={domainNames}
              columnDefs={fqdpDomainColumnDefs}
              onCellValueChanged={onCellValueChanged}
              components={components}
              context={{
                domainNames,
                onClickRemoveDomainItem
              }}
              defaultColDef={{
                flex: 1,
                editable: false,
                floatingFilter: true,
              }}
            />
          </div>
        )}
      </div>
    )
}

export default FqdnDomainFormGrid;
